import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "studentRollChange/";


// 学籍异动 - 列表查询-分页
export const rollChangePage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "myPage", {
    data: _params,
    method: "GET",
  });
};

// 获取当前学籍信息-学生点击申请学籍异动时调用
export const getRollInfo = () => {
  return sendRequest(api.url + _base + "rollInfo", {
    method: "GET",
  });
};

// 申请学籍异动
export const applyRollChange = (params) => {
  return sendRequest(api.url + _base + "apply", {
    data: params,
    method: "POST",
  });
};

// 获取学籍异动详情
export const getRollChangeInfo = (id) => {
  return sendRequest(api.url + _base + "view", {
    data: { id },
    method: "GET",
  });
};


// 修改学籍异动
export const editRollChange = (params) => {
  return sendRequest(api.url + _base + "edit", {
    data: params,
    method: "POST",
  });
};

// 取消学籍异动申请（待审核）
export const cancelRollChange = (id) => {
  return sendRequest(api.url + _base + "cancel", {
    data: Qs.stringify({ id }),
    method: "POST",
  });
};

// 复学、转教学点、转专业等-通过年级获取教学点
export const getUnitByG = (params) => {
  return sendRequest(api.url + _base + "getUnitByG", {
    data: params,
    method: "POST",
  });
};

// 复学、转专业等-通过年级、教学点获取招生专业
export const getMajorByGU = (params) => {
  return sendRequest(api.url + _base + "getMajorByGU", {
    data: params,
    method: "POST",
  });
};

// 复学、转专业、转教学点等-通过年级、教学点、专业获取班级
export const getClassesByGUM = (params) => {
  return sendRequest(api.url + _base + "getClassesByGUM", {
    data: params,
    method: "POST",
  });
};

// 复学、转专业、转教学点等-通过年级、教学点、专业获取基础教学计划
export const getPlanByGUM = (params) => {
  return sendRequest(api.url + _base + "getPlanByGUM", {
    data: params,
    method: "POST",
  });
};
// 获取年级
export const getGrade = (params) => {
  return sendRequest(api.url + _base + "getGrade", {
    data: params,
    method: "GET",
  });
};

// 获取退学退费信息（在校月数、退费月数、退费金额）
export const getDropoutRefundInfo = (rollId) => {
  return sendRequest(api.url + _base + "getDropoutRefundInfo", {
    data: { rollId },
    method: "GET",
  });
};


// WEBPACK FOOTER //
// ./src/fetch/api/rollChange.js